import React, { FunctionComponent } from 'react';
import WithDataRecord from 'hoc/WithDataRecord';
import {
  AdminApi,
  AdminInvestmentList,
  AdminInvestmentsListOrderingEnum,
  InvestmentAcquisitionTypeRecipientEnum,
} from 'api';
import useGoTo from 'hooks/use-go-to';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import StudioConnectedInvestmentsTable from './StudioConnectedInvestmentsTable';
import { PaginationProps } from 'ui/molecules/pagination';

interface ConnectedInvestmentsTableProps {
  voucherId: string;
  forceDataLoad?: boolean;
  defaultLimit?: number;
  paginationProps?: PaginationProps;
}

const ConnectedInvestmentsTable: FunctionComponent<ConnectedInvestmentsTableProps> = WithDataRecord<
  AdminApi,
  AdminInvestmentList
>(AdminApi)(
  ({ data, ordering, onOrderBy, loading, paginationProps, voucherId }) => {
    const goTo = useGoTo(ISSUER_ROUTES.investmentDetails);

    return (
      <>
        <StudioConnectedInvestmentsTable
          voucherId={voucherId}
          loading={loading}
          onOrderBy={onOrderBy}
          ordering={ordering}
          goToDetails={(productId: string, investmentId: string) => goTo({ productId, investmentId })}
          investments={(data || []).map((investment) => ({
            ...investment,
            acquisitionType: investment.acquisitionType || InvestmentAcquisitionTypeRecipientEnum.ISSUANCE,
          }))}
          paginationProps={paginationProps}
        />
      </>
    );
  },
  (api, props, offset, limit, ordering) => {
    return api.adminInvestmentsList({
      offset,
      limit,
      ordering: ordering as AdminInvestmentsListOrderingEnum,
      ...props,
      voucherId: [props.voucherId],
    });
  },
);

export default ConnectedInvestmentsTable;
